import HBIcon from "@/components/HBIcon";
import HBModel from "@/components/HBModal";
import ModalWrap from "@/components/HBModal/ModalWrap";
import { phoneReg, telephoneReg } from "@/constants/ruleReg";
import { submitCompanyVipConsult } from "@/services";
import { useCountries } from "@/utils/hooks/useContries";
import { Button, Form, Input, Select } from "antd";
import classNames from "classnames";
import { useRouter } from "next/router";
import { useCallback, useMemo, useState } from "react";
import { When } from "react-if";
import styles from "./index.module.less";
const initSource = "uS2gcaCak";

// const downloadNumOptions = [
//   {
//     label: "100～500个",
//     value: "100～500个",
//   },
//   {
//     label: "500～3000个",
//     value: "500～3000个",
//   },
//   {
//     label: "3000个以上",
//     value: "3000个以上",
//   },
// ];
enum ACTIVEKEY {
  qrcode,
  form,
}

/** leads_entrance 线索入口
 * 企微;sqw366ynR
 * 首页-顶部导航栏;M2pmhC0aW
 * 会员订购页;CZAd1Dg4j （默认）
 * 支付弹窗;I3NThF9VT
 * 花瓣设计大赛;option1
 * 其他;other
 */
export const LeadsEntrance = {
  /**素材详情页 */
  PinDetail: "KqdnUOWz0",
  /**素材详情页-授权范围信息弹窗 */
  PinDetailAuthDialog: "m1b12A6XX",
  /**会员订购页 */
  VipInfoPage: "CZAd1Dg4j",
  /**顶部导航栏 */
  TopNav: "M2pmhC0aW",
  /**支付弹窗 */
  BuyDialog: "I3NThF9VT",
  /**设计大赛 */
  DesignActivity: "option1",
  /**企业微信 */
  CompanyWeChat: "sqw366ynR",
  /**其他 */
  Other: "other",
  /**搜索 */
  Search: "71RfgnweB",
  /**侧边栏 */
  Sidebar: "5tLl54mg8",
  /**企业咨询页侧边栏 */
  ConsultSidebar: "bewoeP02g",
};

const initLeads_entrance = LeadsEntrance.VipInfoPage;

function FromInfo({ isMobile, config, leads_entrance, ...props }) {
  const [loading, setLoading] = useState(false);
  const router = useRouter();
  const [showSuccess, setShowSuccess] = useState(false);
  const [activeKey, setActiveKey] = useState(ACTIVEKEY.qrcode);
  const query = router.query;

  const tabChange = (value) => {
    setActiveKey(value);
  };
  const qrcodeImg = useMemo(() => {
    const { leads_entrance = "other" } = query;
    const qrcode = config?.qrcodeList?.find(
      (item) => item.leads_entrance === leads_entrance
    )?.img[0].url;

    // 如果没有找到匹配的二维码，尝试使用默认的 "other" 二维码
    return (
      qrcode ||
      config?.qrcodeList?.find((item) => item.leads_entrance === "other")
        ?.img[0].url
    );
  }, [query, config]);

  const { countries } = useCountries();
  const [selectedCountry, setSelectedCountry] = useState("+86");

  const onSubmit = useCallback(
    async (values) => {
      setLoading(true);

      try {
        const result = await submitCompanyVipConsult({
          ...values,
          name: "0", // 联系人填 null
          download_cnt: "0",
          // 添加国家代码到提交数据中
          mobile: values.mobile, // 目前 country 没用
          /** source 线索来源
           * 花瓣;uS2gcaCak (默认)
           * 花瓣企微;b3Hm10j3U
           * 花瓣订购页;hcnEgQh17
           * 花瓣设计大赛;M20NGy5K1
           * 7月花瓣引流稿定;5fc50Ixmf
           * 其他;other
           */
          /** leads_entrance 线索入口
           * 企微;sqw366ynR
           * 首页-顶部导航栏;M2pmhC0aW
           * 会员订购页;CZAd1Dg4j （默认）
           * 支付弹窗;I3NThF9VT
           * 花瓣设计大赛;option1
           * 其他;other
           */
          source: query?.source || initSource,
          leads_entrance:
            query?.leads_entrance || leads_entrance || initLeads_entrance,
        });

        // 提交线索到CRM
        if (!result.err) {
          setShowSuccess(true);
        }
        setLoading(false);
      } catch (error) {
        setLoading(false);
      }
    },
    [leads_entrance, query, selectedCountry]
  );

  return (
    <HBModel
      {...props}
      footer={null}
      title={null}
      bodyStyle={{ padding: 0 }}
      width={isMobile ? "95vw" : 640}
    >
      <div
        className={styles.right}
        data-gd-expose="dialog_expose"
        data-module-name="留资弹窗"
        data-subject-name="弹窗"
      >
        <When condition={isMobile}>
          <div
            className={classNames([
              styles.tab,
              activeKey === ACTIVEKEY.qrcode ? styles.qrcodeBg : styles.formBg,
            ])}
          >
            <div className={classNames(styles.tabConent)}>
              <header
                className={classNames({
                  [styles.active]: activeKey === ACTIVEKEY.qrcode,
                })}
                onClick={() => tabChange(ACTIVEKEY.qrcode)}
              >
                <div className={styles.tabTitle}>添加微信</div>
                <div className={styles.tabDesc}>立即线上沟通</div>
              </header>
            </div>
            <div className={styles.tabConent}>
              <header
                className={classNames({
                  [styles.active]: activeKey === ACTIVEKEY.form,
                })}
                onClick={() => tabChange(ACTIVEKEY.form)}
              >
                <div className={styles.tabTitle}>预留消息</div>
                <div className={styles.tabDesc}>1～2个工作日内联系您</div>
              </header>
            </div>
          </div>
        </When>
        <When condition={!isMobile || activeKey === ACTIVEKEY.qrcode}>
          <div className={styles.formConentBg}>
            <div className={styles.qrcode}>
              <div className={styles.title}>
                {config.qrcodeTopTxt || <DefaultTitle />}
              </div>
              <div className={styles.img}>
                <When condition={qrcodeImg}>
                  <img src={qrcodeImg} alt="二维码" />
                </When>
              </div>
              <div className={styles.qrcodeDesc}>
                {config.qrcodeBottomTxt || (
                  <>
                    仅支持企业会员购买咨询
                    <br />
                    （产品问题请联系在线客服）
                  </>
                )}
              </div>
              {/* <When condition={!isMobile}>
                <div
                  className={styles.help}
                  onClick={openUdesk}
                  data-gd-click="button_click"
                  data-button-name="售后咨询"
                >
                  <HBIcon className={styles.icon} type="ic_severice" />
                  我已购买, 咨询售后
                </div>
              </When> */}
            </div>
          </div>
        </When>
        <When condition={!isMobile || activeKey === ACTIVEKEY.form}>
          <div className={styles.formConentBg}>
            <div className={styles.fromContent}>
              <div className={classNames(styles.title, styles.textAlignLeft)}>
                预留信息，我们将在 1～2 个工作日联系您
              </div>
              {showSuccess ? (
                <div
                  className={styles.success}
                  data-gd-expose="dialog_expose"
                  data-module-name="留资提交成功提示"
                  data-subject-name="弹窗"
                >
                  <HBIcon className={styles.icon} type="ic_check_circle" />
                  <div className={styles.subtitle}>
                    已通知专属顾问，我们将尽快与您联系
                  </div>
                </div>
              ) : (
                <Form
                  className={styles.form}
                  layout="vertical"
                  autoComplete="off"
                  onFinish={onSubmit}
                >
                  <Form.Item
                    label="企业名称"
                    name="company"
                    rules={[{ required: true, message: "企业名称必填" }]}
                  >
                    <Input
                      className={styles.input}
                      placeholder="请输入您的公司/单位/机构名称"
                    />
                  </Form.Item>
                  {/* <Form.Item
                    label="预计每年的下载量"
                    name="download_cnt"
                    rules={[
                      { required: true, message: "预计每年的下载量必选" },
                    ]}
                  >
                    <Radio.Group
                      className={styles.radio}
                      options={downloadNumOptions}
                    />
                  </Form.Item> */}
                  {/* <Form.Item
                    label="联系人"
                    name="name"
                    rules={[{ required: true, message: "联系人必填" }]}
                  >
                    <Input
                      className={styles.input}
                      placeholder="请输入联系人"
                    />
                  </Form.Item> */}
                  <Form.Item
                    label="手机号"
                    name="mobile"
                    rules={[
                      { required: true, message: "手机号必填" },
                      {
                        message:
                          "请输入正确的手机或固定电话号码，例如：13512345678或0592-8263159",
                        validator(_, value) {
                          if (value) {
                            if (
                              phoneReg.test(value) ||
                              telephoneReg.test(value)
                            ) {
                              return Promise.resolve();
                            } else {
                              return Promise.reject();
                            }
                          } else {
                            return Promise.resolve();
                          }
                        },
                      },
                    ]}
                  >
                    <Input
                      className={styles.input}
                      placeholder="请输入您的联系电话"
                      addonBefore={
                        <Select
                          value={selectedCountry}
                          onChange={(value: any) => setSelectedCountry(value)}
                          style={{ width: 78 }}
                          optionLabelProp="value"
                          options={countries.map((country) => ({
                            label: `${country.name} ${country.code}`,
                            value: country.code,
                          }))}
                          dropdownMatchSelectWidth={false}
                        />
                      }
                    />
                  </Form.Item>
                  <div className={styles.formGap} />
                  <div className={styles.submit}>
                    <Button
                      className={styles.button}
                      type="primary"
                      htmlType="submit"
                      data-gd-click="button_click"
                      data-button-name="立即获取方案"
                      loading={loading}
                    >
                      立即获取方案
                    </Button>
                  </div>
                </Form>
              )}
            </div>
          </div>
        </When>
      </div>
    </HBModel>
  );
}

function DefaultTitle() {
  return (
    <div className={styles.defaultTitle}>
      扫码添加<span className={styles.defaultTitleHighlight}>微信</span>
      <br />
      获取企业购买方案
    </div>
  );
}

const FromDialog = ModalWrap(FromInfo);
export default FromDialog;
